export const BILLING_DEFAULT_OPEN = true;

export function hasBillingAccess() {
  const flag = localStorage.getItem("billingAccess");

  if (flag === "true") return true;
  if (flag === "false") return false;

  return BILLING_DEFAULT_OPEN;
}
